export const role = {
    Admin: 'Admin',
    Company: 'Company',
    HiringManager: 'HiringManager',
    Recruiter: 'Recruiter',
    Concierge: 'Concierge',
    Interviewer: 'Interviewer',
    Candidate: 'Candidate'
}